import { Column, Entity, OneToMany } from 'typeorm';
import { AuditEntity } from './audit.entity';
import { BaseEntity } from './base.entity';
import { TriggerGroupStateHistoryEntity } from './trigger-group-state-history.entity';

@Entity('_trigger')
export class TriggerEntity extends BaseEntity {
	@Column('varchar', { name: '_name', length: 255 })
	public name!: string;

	@Column('int', { name: '_fk__object__id', unsigned: true })
	public fkObjectId!: number;

	@Column('int', { name: '_fk__trigger_group__id', unsigned: true })
	public fkTriggerGroupId!: number;

	@Column('int', {
		name: '_fk__trigger__id_match',
		nullable: true,
		unsigned: true,
	})
	public fkTriggerIdMatch!: number | null;

	@Column('int', {
		name: '_fk__trigger__id_noMatch',
		nullable: true,
		unsigned: true,
	})
	public fkTriggerIdNoMatch!: number | null;

	@Column({ type: 'boolean', name: '_throwOnMatch', width: 1, default: () => "'0'" })
	public throwOnMatch!: boolean;

	@Column({
		type: 'boolean',
		name: '_throwOnNoMatch',
		width: 1,
		default: () => "'0'",
	})
	public throwOnNoMatch!: boolean;

	@Column({ type: 'boolean', name: '_first', width: 1, default: () => "'0'" })
	public first!: boolean;

	@Column('text', { name: '_filter' })
	public filter!: string;

	@Column('varchar', { name: '_type', length: 255 })
	public type!: string;

	@OneToMany(() => AuditEntity, (audit) => audit.fkTrigger, {})
	public audits!: Array<AuditEntity>;

	@OneToMany(
		() => TriggerGroupStateHistoryEntity,
		(triggerGroupStateHistory) => triggerGroupStateHistory.fkTrigger,
		{},
	)
	public triggerGroupStateHistories!: Array<TriggerGroupStateHistoryEntity>;
}
